import { Text } from '@react-pdf/renderer';

type PartOptionsProps = {
  partOptions: {
    id: string;
    name: string;
    groupName: string;
  }[];
};

export function PartOptions({ partOptions }: PartOptionsProps) {
  return (
    <>
      {partOptions.map((option) => {
        if (option.name === 'None') {
          return null;
        }

        return (
          <Text key={option.id}>{`${option.groupName}: ${option.name}`}</Text>
        );
      })}
    </>
  );
}
